export default __webpack_public_path__ + "static/media/Icon-prev.dd4162bb.svg";